import { Head, useForm, Link } from "@inertiajs/react";
import PlainLayout from "@/layouts/plain-layout";

import { new_session_path, passwords_path } from "@/routes";

function NewPassword({ email }) {
  const { data, setData, post, processing } = useForm({ email: email || "" });

  const submit = (e) => {
    e.preventDefault();
    post(passwords_path());
  };

  return (
    <>
      <Head title="Glemt adgangskode" />

      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-sm rounded-4 border-0">
              <div className="card-body p-4">
                <h1 className="h4 text-center fw-semibold mb-4">Glemt din adgangskode?</h1>
                <form className="vstack gap-3" onSubmit={submit}>
                  <div>
                    <label className="form-label">E-mail</label>
                    <input className="form-control" value={data.email} onChange={(e) => setData("email", e.target.value)} required />
                  </div>
                  <button className="btn btn-primary w-100 rounded-3 py-2 fw-semibold" disabled={processing}>Send nulstillingslink</button>
                </form>
                <div className="text-center mt-3">
                  <Link href={new_session_path()} className="small text-decoration-none">Tilbage til log ind</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

NewPassword.layout = (page) => <PlainLayout>{page}</PlainLayout>;

export default NewPassword;
